import React, { useEffect } from 'react';
import type { NextPage } from 'next';
import JsRegister from '../components/jobseeker/Register/JsRegister';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import MetaTags from 'src/components/metaTags/MetaTags';
const domainURL = process.env.NEXT_PUBLIC_REACT_APP_DOMAIN;
const RegisterPage: NextPage = props => {
  const router = useRouter();
  const auth = useSelector((state: any) => state.auth);
  useEffect(() => {
    // redirect to home if already logged in
    if (auth?.token) {
      router.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {!auth?.token ? (
        <React.Fragment>
          <MetaTags title={'Register on JobsHorn'} link={domainURL + '/register'}></MetaTags>
          <JsRegister />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};
export default RegisterPage;
